var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.enabled)?_c('goods-item',{attrs:{"model":_vm.model,"good":_vm.good,"store-lang":_vm.$store.state.locale.locale},on:{"refresh":_vm.init}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }